import React from "react";

function EmptyBoxDataIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#b9acac"
        d="M512 188.224v294.652c0 5.275-4.275 9.55-9.56 9.55H291.562c-5.275 0-9.56-4.275-9.56-9.55V188.224c0-5.275 4.286-9.56 9.56-9.56H502.44c5.285 0 9.56 4.286 9.56 9.56z"
        data-original="#b9acac"
      ></path>
      <g fill="#9e9797">
        <path
          d="M386.493 178.664v282.404a11.049 11.049 0 01-11.054 11.054h-93.437V188.224c0-5.275 4.286-9.56 9.56-9.56z"
          data-original="#9e9797"
        ></path>
        <path
          d="M512 262.508v-74.284c0-5.278-4.279-9.558-9.557-9.558h-210.88c-5.278 0-9.558 4.279-9.558 9.558v74.284z"
          data-original="#9e9797"
        ></path>
        <path
          d="M511.996 188.22v294.653a9.553 9.553 0 01-9.558 9.558h-32.414a9.554 9.554 0 009.558-9.558V188.22c0-5.273-4.276-9.558-9.558-9.558h32.414c5.283 0 9.558 4.285 9.558 9.558z"
          data-original="#9e9797"
        ></path>
      </g>
      <path
        fill="#3ad1e0"
        d="M512 188.224v44.978H282.002v-44.978c0-5.275 4.286-9.56 9.56-9.56H502.44c5.285 0 9.56 4.286 9.56 9.56z"
        data-original="#3ad1e0"
      ></path>
      <path
        fill="#20bfd5"
        d="M417.326 189.337c0 15.216-12.331 27.557-27.547 27.557-15.226 0-27.557-12.342-27.557-27.557 0-3.791.762-7.397 2.143-10.673h50.819a27.426 27.426 0 012.142 10.673zm94.67-1.117v44.982h-32.414V188.22c0-5.273-4.276-9.558-9.558-9.558h32.414c5.283 0 9.558 4.285 9.558 9.558z"
        data-original="#20bfd5"
      ></path>
      <path
        fill="#b9acac"
        d="M229.998 188.224v294.652c0 5.275-4.286 9.55-9.56 9.55H9.56c-5.285 0-9.56-4.275-9.56-9.55V188.224c0-5.275 4.275-9.56 9.56-9.56h210.878c5.275 0 9.56 4.286 9.56 9.56z"
        data-original="#b9acac"
      ></path>
      <g fill="#9e9797">
        <path
          d="M229.998 188.224v283.897h-98.454c-6.099 0-11.054-4.945-11.054-11.054V178.664h99.948c5.275 0 9.56 4.286 9.56 9.56z"
          data-original="#9e9797"
        ></path>
        <path
          d="M229.995 262.508v-74.284c0-5.278-4.279-9.558-9.558-9.558H9.557c-5.278 0-9.557 4.279-9.557 9.558v74.284z"
          data-original="#9e9797"
        ></path>
        <path
          d="M229.992 188.22v294.653a9.553 9.553 0 01-9.557 9.558h-32.414a9.554 9.554 0 009.558-9.558V188.22c0-5.273-4.276-9.558-9.558-9.558h32.414c5.281 0 9.557 4.285 9.557 9.558z"
          data-original="#9e9797"
        ></path>
      </g>
      <path
        fill="#3ad1e0"
        d="M229.995 233.205H0v-44.982a9.557 9.557 0 019.557-9.557h210.88a9.557 9.557 0 019.557 9.557v44.982z"
        data-original="#3ad1e0"
      ></path>
      <path
        fill="#20bfd5"
        d="M229.992 188.22v44.982h-32.414V188.22c0-5.273-4.276-9.558-9.558-9.558h32.414c5.282 0 9.558 4.285 9.558 9.558z"
        data-original="#20bfd5"
      ></path>
      <path
        fill="#f8f3f1"
        d="M375.443 447.732H131.548c-6.105 0-11.054-4.949-11.054-11.054V95.9c0-6.105 4.949-11.054 11.054-11.054h243.895c6.105 0 11.054 4.949 11.054 11.054v340.779c0 6.105-4.949 11.053-11.054 11.053z"
        data-original="#f8f3f1"
      ></path>
      <path
        fill="#efe2dd"
        d="M386.497 176.885V95.9c0-6.105-4.949-11.054-11.054-11.054H131.548c-6.105 0-11.054 4.949-11.054 11.054v80.986h266.003z"
        data-original="#efe2dd"
      ></path>
      <path
        fill="#efe2dd"
        d="M386.493 95.895v340.784a11.049 11.049 0 01-11.054 11.054h-37.488a11.049 11.049 0 0011.054-11.054V95.895c0-6.099-4.945-11.054-11.054-11.054h37.488c6.109 0 11.054 4.956 11.054 11.054z"
        data-original="#efe2dd"
      ></path>
      <path
        fill="#31a7fb"
        d="M386.493 95.899v52.024H120.49V95.899c0-6.109 4.955-11.054 11.054-11.054h243.895c6.109.001 11.054 4.945 11.054 11.054z"
        data-original="#31a7fb"
      ></path>
      <path
        fill="#1c96f9"
        d="M337.951 93.901c0 13.506-10.951 24.467-24.467 24.467s-24.467-10.961-24.467-24.467c0-3.204.618-6.253 1.741-9.055h45.452a24.26 24.26 0 011.741 9.055zm48.542 1.994v52.024h-37.488V95.895c0-6.099-4.945-11.054-11.054-11.054h37.488c6.109 0 11.054 4.956 11.054 11.054z"
        data-original="#1c96f9"
      ></path>
      <path
        fill="#99d53b"
        d="M271.059 321.779a7.698 7.698 0 01-5.013-1.85c-3.467-2.96-8.413-4.666-13.57-4.682h-.069c-5.132 0-10.058 1.675-13.528 4.6a7.723 7.723 0 01-10.887-.926 7.725 7.725 0 01.926-10.887c6.303-5.316 14.641-8.24 23.486-8.24h.119c8.89.027 17.256 3.004 23.556 8.381a7.728 7.728 0 01-5.02 13.604zM211.5 286.66h-.044c-4.267-.024-7.753-3.503-7.729-7.77.024-4.252 3.434-7.684 7.68-7.684h.135a7.728 7.728 0 01-.042 15.454z"
        data-original="#99d53b"
      ></path>
      <path
        fill="#f8f3f1"
        d="M159.866 124.046h-.041c-4.267-.022-7.758-3.499-7.735-7.767.022-4.253 3.429-7.687 7.677-7.687h.041l.098.001a7.727 7.727 0 01-.04 15.453z"
        data-original="#f8f3f1"
      ></path>
      <path
        fill="#f8f3f1"
        d="M159.854 124.046c-4.267 0-7.774-3.459-7.774-7.726s3.411-7.726 7.678-7.726h.096a7.726 7.726 0 110 15.452zm23.373 0c-4.267 0-7.775-3.459-7.775-7.726s3.411-7.726 7.679-7.726h.096a7.726 7.726 0 110 15.452zm23.375 0c-4.267 0-7.775-3.459-7.775-7.726s3.411-7.726 7.679-7.726h.096a7.726 7.726 0 110 15.452z"
        data-original="#f8f3f1"
      ></path>
      <path
        fill="#bcea73"
        d="M79.115 110.855a7.727 7.727 0 00-10.927 0l-4.116 4.116-4.116-4.116a7.725 7.725 0 00-10.927 0 7.725 7.725 0 000 10.927l4.116 4.116-4.116 4.116a7.725 7.725 0 000 10.927c1.509 1.509 3.486 2.263 5.463 2.263s3.955-.755 5.463-2.263l4.116-4.116 4.116 4.116c1.509 1.509 3.486 2.263 5.463 2.263s3.955-.755 5.463-2.263a7.725 7.725 0 000-10.927l-4.116-4.116 4.116-4.116a7.725 7.725 0 00.002-10.927zm382.679 5.464l4.116-4.116a7.727 7.727 0 00-10.927-10.927l-4.116 4.116-4.116-4.116a7.727 7.727 0 00-10.927 10.927l4.116 4.116-4.116 4.116a7.725 7.725 0 000 10.927c1.509 1.509 3.486 2.263 5.463 2.263s3.955-.755 5.463-2.263l4.116-4.116 4.116 4.116c1.509 1.509 3.486 2.263 5.463 2.263s3.955-.755 5.463-2.263a7.725 7.725 0 000-10.927z"
        data-original="#bcea73"
      ></path>
      <path
        fill="#64b9fc"
        d="M269.222 21.832a7.727 7.727 0 00-10.927 0l-4.116 4.116-4.116-4.116a7.727 7.727 0 00-10.927 10.927l4.116 4.116-4.116 4.116a7.725 7.725 0 000 10.927c1.509 1.509 3.486 2.263 5.463 2.263s3.955-.755 5.463-2.263l4.116-4.116 4.116 4.116c1.509 1.509 3.486 2.263 5.463 2.263s3.955-.755 5.463-2.263a7.725 7.725 0 000-10.927l-4.116-4.116 4.116-4.116a7.724 7.724 0 00.002-10.927z"
        data-original="#64b9fc"
      ></path>
      <path
        fill="#bcea73"
        d="M362.222 166.93c0-15.217 12.336-27.552 27.552-27.552 15.217 0 27.552 12.336 27.552 27.552s-12.336 27.552-27.552 27.552-27.552-12.336-27.552-27.552"
        data-original="#bcea73"
      ></path>
      <path
        fill="#99d53b"
        d="M375.8 190.673c10.816-2.493 18.874-12.175 18.874-23.746 0-11.559-8.046-21.254-18.861-23.747a27.353 27.353 0 0113.963-3.803c15.21 0 27.549 12.339 27.549 27.549 0 15.222-12.339 27.561-27.549 27.561a27.282 27.282 0 01-13.976-3.814"
        data-original="#99d53b"
      ></path>
      <path
        fill="#a8e7ef"
        d="M289.017 69.431c0-13.513 10.954-24.467 24.467-24.467s24.467 10.954 24.467 24.467-10.954 24.467-24.467 24.467-24.467-10.954-24.467-24.467"
        data-original="#a8e7ef"
      ></path>
      <path
        fill="#70d9e6"
        d="M301.074 90.516c9.604-2.214 16.76-10.812 16.76-21.087 0-10.264-7.145-18.874-16.749-21.087a24.292 24.292 0 0112.4-3.377c13.507 0 24.464 10.957 24.464 24.464 0 13.518-10.957 24.475-24.464 24.475-4.528 0-8.777-1.23-12.411-3.388"
        data-original="#70d9e6"
      ></path>
      <path
        fill="#99d53b"
        d="M295.573 286.66h-.044c-4.267-.024-7.753-3.503-7.729-7.77.024-4.252 3.434-7.684 7.68-7.684h.135a7.728 7.728 0 01-.042 15.454z"
        data-original="#99d53b"
      ></path>
    </svg>
  );
}

export default EmptyBoxDataIcon;